import css from 'styled-jsx/css';
import { common } from '../../theme/theme';

const style = css`
  .update-car-area-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .area-selector-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .comment-form {
    margin-bottom: 16px;
  }
  .update-car-area-modal :global(textarea.text-area) {
    resize: none;
    border: solid 1px #676767;
    border-radius: 4px;
    font-size: 16px;
  }
  .update-car-area-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-car-area-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .comment-area {
    border: 1px solid #676767;
    border-radius: 4px;
    width: 100%;
    height: 90px;
    resize: none;
  }
`;

export default style;
